/**
 * Coffee.jsx
 * Posts about coffee — a little personality.
 */

import { PostsSummary } from '#components/PostsSummary';

export function Coffee(){
	return (<section>
		<div className="section-head">
			<span className="eyebrow">Off the Clock</span>
			<h2>Coffee</h2>
		</div>
		<PostsSummary noResultsText='No coffee posts yet.' tags={['coffee']} />
	</section>);
}
